<template>
    <div class="row hoverable" v-if="model">
        <div class="col">{{model.label}} <small><i>({{model.description}} <a @click="changeDescription" href="#">zmień opis</a>)</i></small></div>
        <div class="col-auto">
            <publish-button :model="model" :what="attrCategory"/>
            <q-btn flat round icon="edit" @click="toggleEdit"></q-btn>
            <q-btn flat round icon="delete" @click="confirmAndDelete" :disable="model.publicationInformation.status !== 'Unpublished'"></q-btn>
        </div>
    </div>
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import PublishButton from './pole/PublishButton'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QField from 'quasar-framework/src/components/field/QField'
    import QInput from 'quasar-framework/src/components/input/QInput'

    export default {
        name: 'CategoryEntry',
        props: ['model', 'isNew', 'kb'],
        components: {QInput, QField, QBtn, PublishButton, QIcon},
        mounted () {
            if (this.model) {
                this.localLabel = this.model.label
            }
        },
        watch: {
            model (current) {
                if (current) {
                    this.localLabel = current.label
                }
            }
        },
        data () {
            return {
                inEdit: false,
                localLabel: '',
            }
        },
        methods: {
            toggleEdit () {
                this.$q.dialog({
                    title: 'Zmień nazwę kategorii',
                    prompt: {
                        model: this.model.label,
                        type: 'text'
                    },
                    cancel: true,
                    color: 'secondary'
                }).then(data => {
                    if (data && data.length > 0) {
                        this.$store.dispatch('update', {
                            what: this.attrCategory,
                            item: {
                                [this.attrCategory]: this.model[this.attrCategory],
                                description: this.model.description,
                                label: data,
                            },
                        })
                    } else {
                        this.$q.notify('Nazwa nie może być pusta')
                    }
                }).catch(() => {})

            },
            changeDescription() {
                this.$q.dialog({
                    title: 'Zmień opis kategorii',
                    prompt: {
                        model: this.model.description,
                        type: 'text'
                    },
                    cancel: true,
                    color: 'secondary'
                }).then(data => {
                    this.$store.dispatch('update', {
                        what: this.attrCategory,
                        item: {
                            [this.attrCategory]: this.model[this.attrCategory],
                            description: data,
                            label: this.model.label,
                        },
                    })
                }).catch(() => {})

            },
            confirmAndDelete () {
                if (this.model[this.attrCategory]) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie kategorii`,
                        message: `Czy na pewno usunąć kategorię ${this.model.label}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('remove', {
                            what: this.attrCategory,
                            id: this.model[this.attrCategory]
                        })
                    }).catch(() => { })
                } else {
                    this.$emit('delete');
                }
            },
        },
        computed: {
            attrCategory () {
                return this.kb ? 'kbCategory' : 'category'
            }
        }
    }
</script>

<style scoped lang="scss">
    .hoverable {
        &:hover {
            background-color: rgba(0,0,0,0.1);
        }
    }
</style>